var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviantart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44862 22.7298L11.6887 18.4555L18.6438 18.4439V13.0768L14.5037 13.0719L18.6438 5.1775V1.2702H14.5505L12.3104 5.55827L5.35645 5.56652V10.9232L9.49979 10.9215L5.35645 18.8329V22.7298H9.44862Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviantart);
export default __webpack_public_path__ + "static/media/deviantart.5b253db307c86e77cd46ced7662b5ab8.svg";
export { ForwardRef as ReactComponent };